// extracted by mini-css-extract-plugin
export default {"chooseUs":"HomeChooseUs_chooseUs__obkg2","imgPart":"HomeChooseUs_imgPart__KisfM","textPart":"HomeChooseUs_textPart__aqn4x"};